import { render, staticRenderFns } from "./ViewLayout.vue?vue&type=template&id=206d43d3&lang=pug&"
import script from "./ViewLayout.vue?vue&type=script&lang=js&"
export * from "./ViewLayout.vue?vue&type=script&lang=js&"
import style0 from "./ViewLayout.vue?vue&type=style&index=0&id=206d43d3&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports